const invyntraPoints = [
  '15-day free trial, no credit card required',
  'Sales & purchase orders with automatic stock updates',
  'Dashboard with stock value & low-stock alerts',
  'Team access with Admin / Manager / Staff roles',
  'Export invoices as PDF, reports to Excel',
];

function Products() {
  return (
    <section id="products" className="bg-canvas-alt py-[88px]">
      <div className="wrap">
        <div className="mx-auto mb-12 max-w-[640px] text-center">
          <p className="eyebrow">Our Products</p>
          <h2>Software we build and run ourselves</h2>
          <p className="section-lead">
            Alongside client work, we build our own products for problems we know well.
          </p>
        </div>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(320px,1fr))] gap-7">
          <article className="card flex flex-col p-9">
            <div className="mb-1.5 flex items-center gap-3">
              <h3>Invyntra</h3>
              <span className="badge bg-[#e3f8ef] text-[#148a5c]">Live</span>
            </div>
            <p className="mb-[14px] mt-1 font-semibold text-navy">
              Inventory management for small & growing businesses
            </p>
            <p>
              Invyntra replaces spreadsheets and notebooks for tracking stock, purchases,
              and sales. Every business gets its own private workspace — sales and purchase
              orders update stock automatically, and a live dashboard flags low stock before
              it becomes a problem.
            </p>
            <ul className="mb-6 mt-1 flex-grow list-none p-0">
              {invyntraPoints.map((point) => (
                <li key={point} className="bullet before:bg-blue">
                  {point}
                </li>
              ))}
            </ul>
            <a
              className="btn-primary self-start"
              href="https://invyntra.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit invyntra.in
            </a>
          </article>

          <article className="card flex flex-col p-9">
            <div className="mb-1.5 flex items-center gap-3">
              <h3>Scholl OS</h3>
              <span className="badge bg-[#fef3e2] text-[#b7791f]">Coming Soon</span>
            </div>
            <p className="mb-[14px] mt-1 font-semibold text-navy">
              A new platform for schools, from Venus Solutions
            </p>
            <p>
              Scholl OS is our next product, currently in development. We&apos;ll share
              details as it gets closer to launch — in the meantime, reach out if you&apos;d
              like to be one of the first to know.
            </p>
            <a className="btn-outline self-start" href="#contact">
              Get Notified
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}

export default Products;
